import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { buscarAsesorias, filtrarAsesorias } from '../../actions/asesorias';
import { buscarUsuarios, limpiarUsuarios } from '../../actions/usuarios';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const FiltrosAsesorias = () => {

    const dispatch =  useDispatch();

    const { usuario } = useSelector(state => state.auth);
    const { ventana_filtros } = useSelector(state => state.asesorias);
    const { listado: listadoUsuarios } = useSelector(state => state.usuarios);

    const [statusProcesar, setStatusProcesar] = useState(false);

    const [filtrosData, setFiltrosData] = useState({
        cliente: null,
        asesor: null,
        status: [0],
        fecha_inicio: null,
        fecha_fin: null
    });

    const [asesorData, setAsesorData] = useState(null);
    const [asesoresFilter, setAsesoresFilter] = useState([]);

    const [statusData, setStatusData] = useState([
        { value: 0, label: 'En curso' }
    ]);

    const statusFilter = [
        { value: 0, label: 'En curso' }, 
        { value: 1, label: 'Finalizada' }
    ];

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided, 
        }),
        control: (provided, state) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Filtros */
    const handleAbrir = () => {
        if(usuario?.tipo == 0){
            dispatch(buscarUsuarios({
                id: null,
                nombre: null,
                apellido_paterno: null,
                apellido_materno: null,
                tipo: null,
                fecha_inicio: null,
                fecha_fin: null
            }));
        }
    }

    const handleInputChange = ({ target }) => {
        setFiltrosData({
            ...filtrosData,
            [target.name]: target.value
        });
    }

    const handleSelectAsesor = (option) => {
        setAsesorData(option);
        setFiltrosData({
            ...filtrosData,
            asesor: option ? option.value : null
        });
    }

    const handleSelectStatus = (option) => {
        setStatusData(option);

        let status = [];

        for (var i = 0; i < option?.length; i++) {
            status.push(option[i].value);
        }

        setFiltrosData({
            ...filtrosData,
            status
        });
    }

    const handleDatePicker = (name, value) => {
        setFiltrosData({
            ...filtrosData,
            [name]: value
        });
    }
    
    const handleProcesar = async (filtros) => {
        await setStatusProcesar(true);

        if(!filtros){
            await dispatch(buscarAsesorias(filtrosData));
        }else{
            let datos_base = {
                ...filtrosData,
                cliente: null,
                asesor: null,
                status: [0, 1],
                fecha_inicio: null,
                fecha_fin: null
            };

            setStatusData([]);
            setAsesorData(null);

            await dispatch(buscarAsesorias(datos_base));

            await setFiltrosData(datos_base);
        }
        
        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            dispatch(filtrarAsesorias(false));
            dispatch(limpiarUsuarios());
        }
    }

    useEffect(() => {
        const options = listadoUsuarios?.map(u => ({
            value: u._id,
            label: [u.nombre, u.apellido_paterno, u.apellido_materno].filter(Boolean).join(' ')
        })) || [];
        setAsesoresFilter(options);
    }, [listadoUsuarios]);

    return (
        <Modal show={ventana_filtros} size="lg" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Filtrar asesorías</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Cliente" id="cliente" name="cliente" value={filtrosData.cliente} onChange={e => handleInputChange(e)} />
                                <label htmlFor="cliente">Cliente</label>
                            </div>
                        </div>
                    </div>

                    {
                        usuario?.tipo == 0 &&
                            <div className="col-md-6 form-group mb-3">
                                <div className="input-group contenedor-select">
                                    <Select
                                        id="asesor"
                                        name="asesor"
                                        className="select-group"
                                        classNamePrefix="react-select"
                                        placeholder="Asesor"
                                        isClearable={true}
                                        options={asesoresFilter}
                                        value={asesorData}
                                        onChange={(value) => handleSelectAsesor(value)}
                                        menuPortalTarget={document.body}
                                        components={{ ValueContainer: CustomValueContainer }}
                                        styles={{ ...styles_select }}
                                    />
                                </div>
                            </div>
                    }

                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group contenedor-select">
                            <Select
                                id="status"
                                name="status"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Seleccionar estado"
                                isClearable 
                                isMulti={true} 
                                options={statusFilter}
                                value={statusData}
                                onChange={(value) => handleSelectStatus(value)}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-3 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_inicio"
                                    name="fecha_inicio"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    locale="es-ES"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={ filtrosData.fecha_inicio != null ? new Date(filtrosData.fecha_inicio) : '' }
                                    onChange={ date => handleDatePicker('fecha_inicio', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_inicio">Fecha inicial de creación</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    id="fecha_fin"
                                    name="fecha_fin"
                                    className="form-control text-center input-datepícker"
                                    dateFormat="dd/MM/yyyy"
                                    locale="es-ES"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={ filtrosData.fecha_fin != null ? new Date(filtrosData.fecha_fin) : '' }
                                    onChange={ date => handleDatePicker('fecha_fin', date) }
                                />
                                <label className="label-datepicker" htmlFor="fecha_fin">Fecha final de creación</label>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <>
                            <button type="button" className="btn btn-primary" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Buscar todos</button>
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Buscar</button>
                        </>
                    :
                        <>
                            <button type="button" className="btn btn-primary" onClick={() => handleProcesar(true)}><i className="fas fa-search fa-sm"></i> Buscar todos</button>
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar(false)}><i className="fas fa-search fa-sm"></i> Buscar</button>
                        </>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default FiltrosAsesorias;